// extracted by mini-css-extract-plugin
export default {"list":"style_list__dYwYD","list__item":"style_list__item__xN8VB","link":"style_link__9fU8G"};